import { Box } from '@mui/material';
import { fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';
import { type FC, type ReactNode, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthContext } from '../../contexts';
import { getUserInfoBySub } from '../../models';

interface BaseLayoutProps {
  children?: ReactNode;
}

export const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  const { setLoading, setAwsAuth, setAuth, auth } = useContext(AuthContext);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { username } = await getCurrentUser();
        const attributes = await fetchUserAttributes();
        setAwsAuth(attributes);
        if (username && auth === undefined) {
          const userInfo = await getUserInfoBySub(username);
          setAuth(userInfo);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
    //todo:v2-changes
  }, []);
  return (
    <Box
      sx={{
        flex: 1,
        height: '100%'
      }}
    >
      {children || <Outlet />}
    </Box>
  );
};
